import { FC, useEffect, useState } from 'react';
import { isEmpty } from 'radash';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { popularSearchStore } from '@modules/search/adapter/outbound/stores/popularSearch.store';
import { searchResultStore } from '@modules/search/adapter/outbound/stores/searchResult.store';
import { suggestSearchStore } from '@modules/search/adapter/outbound/stores/suggestSearch.store';
import { useDebounce, useLocalStorage } from '@shared/utils/hooks/';
import useLockedBody from '@shared/utils/hooks/useLockedBody.utils';
import { analytics } from '@shared/utils/segment.utils';
import SearchBox from './SearchBox';
const SearchBoxLogic: FC = () => {
  const [_locked, setLocked] = useLockedBody(false, 'root');
  const [searchValue, setSearchValue] = useState<string>('');
  const debouncedValue = useDebounce<string>(searchValue, 500);
  const {
    isSearchModalOpen,
    setIsSearchModalOpen
  } = headerStore(state => state);
  const {
    popularSearch,
    setPopularSearch
  } = popularSearchStore(state => state);
  const [recentlySearch, setRecentlySearch] = useLocalStorage('recentlySearch', []);
  const {
    suggestSearch,
    fetchSuggestSearch
  } = suggestSearchStore(state => state);
  const {
    setSearchProducts,
    setSearchRecipes,
    setSearchTipsTricks
  } = searchResultStore(state => state);
  useEffect(() => {
    setLocked(isSearchModalOpen);
    if (isSearchModalOpen) {
      if (isEmpty(popularSearch)) setPopularSearch();
      analytics.track('Search Button Click', {
        event: 'Search Button Click'
      });
    }
  }, [isSearchModalOpen]);
  useEffect(() => {
    isSearchModalOpen && fetchSuggestSearch(debouncedValue);
  }, [debouncedValue]);
  const onSearchSubmit = (keyword: string, category: string) => {
    const searchParams = {
      keyword,
      currentPage: 1,
      pageSize: 24,
      isSearchNewKeyword: true
    };
    if (category === 'product') {
      setSearchProducts(searchParams);
    } else if (category === 'tipsandtricks') {
      setSearchTipsTricks(searchParams);
    } else {
      setSearchRecipes(searchParams);
    }
  };
  return <SearchBox popularSearch={popularSearch} recentlySearch={recentlySearch} setRecentlySearch={setRecentlySearch} onSearchSubmit={onSearchSubmit} suggestSearch={suggestSearch} isSearchModalOpen={isSearchModalOpen} setIsSearchModalOpen={setIsSearchModalOpen} searchValue={searchValue} setSearchValue={setSearchValue} />;
};
export default SearchBoxLogic;